// /* eslint-disable no-unused-vars */
// import React, { useState, useEffect } from "react";
// import "../assets/ManagePermission.css";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   assignPermissions,
//   fetchRoles,
//   fetchBranches,
//   fetchEmployees,
// } from "../redux/slices/permissionSlice";

// let permissionIdCounter = 1;
// const allModules = {
//   customer: {
//     title: "Customer",
//     permissions: [
//       { id: permissionIdCounter++, label: "Create Customer", icon: "fas fa-id-card" },
//       { id: permissionIdCounter++, label: "Search Customer", icon: "fas fa-search" },
//       { id: permissionIdCounter++, label: "Customer KYC", icon: "fas fa-folder" },
//       { id: permissionIdCounter++, label: "Customer Report", icon: "fas fa-file-alt" },
//     ],
//   },
//   hrmodule: {
//     title: "HR Module",
//     permissions: [
//       { id: permissionIdCounter++, label: "Employee Management", icon: "fas fa-id-badge" },
//       { id: permissionIdCounter++, label: "Attendance", icon: "fas fa-calendar-check" },
//       { id: permissionIdCounter++, label: "Payroll", icon: "fas fa-file-invoice" },
//       { id: permissionIdCounter++, label: "Leave Management", icon: "fas fa-user-clock" },
//     ],
//   },
//   loans: {
//     title: "Loans",
//     permissions: [
//       { id: permissionIdCounter++, label: "Loan Applications", icon: "fas fa-file-signature" },
//       { id: permissionIdCounter++, label: "Approvals", icon: "fas fa-check-circle" },
//       { id: permissionIdCounter++, label: "Payment Tracking", icon: "fas fa-file-invoice-dollar" },
//     ],
//   },
//   banking: {
//     title: "Banking",
//     permissions: [
//       { id: permissionIdCounter++, label: "Account Management", icon: "fas fa-university" },
//       { id: permissionIdCounter++, label: "Transactions", icon: "fas fa-exchange-alt" },
//       { id: permissionIdCounter++, label: "Reports", icon: "fas fa-chart-line" },
//     ],
//   },
//   ledger: {
//     title: "Ledger",
//     permissions: [
//       { id: permissionIdCounter++, label: "View Ledger", icon: "fas fa-book" },
//       { id: permissionIdCounter++, label: "Edit Ledger", icon: "fas fa-pen" },
//     ],
//   },
//   transactions: {
//     title: "Transactions",
//     permissions: [
//       { id: permissionIdCounter++, label: "Make Transaction", icon: "fas fa-money-bill" },
//       { id: permissionIdCounter++, label: "Transaction History", icon: "fas fa-history" },
//     ],
//   },
//   print: {
//     title: "Print",
//     permissions: [
//       { id: permissionIdCounter++, label: "Print Report", icon: "fas fa-print" },
//       { id: permissionIdCounter++, label: "Print Statement", icon: "fas fa-print" },
//     ],
//   },
//   profile: {
//     title: "Profile",
//     permissions: [
//       { id: permissionIdCounter++, label: "View Profile", icon: "fas fa-user" },
//       { id: permissionIdCounter++, label: "Edit Profile", icon: "fas fa-edit" },
//     ],
//   },
//   ccloan: {
//     title: "CC Loan",
//     permissions: [
//       { id: permissionIdCounter++, label: "CC Application", icon: "fas fa-piggy-bank" },
//       { id: permissionIdCounter++, label: "CC Approval", icon: "fas fa-thumbs-up" },
//     ],
//   },
//   additional: {
//     title: "Additional",
//     permissions: [
//       { id: permissionIdCounter++, label: "Settings", icon: "fas fa-cogs" },
//       { id: permissionIdCounter++, label: "Tools", icon: "fas fa-tools" },
//     ],
//   },
//   grouploan: {
//     title: "Group Loan",
//     permissions: [
//       { id: permissionIdCounter++, label: "Group Center", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Loan Status", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Emi Due Report Group", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Emi Due Report Member", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Create", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Loan Report", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Loan Scheme", icon: "fa fa-users-cog" },
//     ],
//   },
// };




// export default function ManagePermission() {
//   const dispatch = useDispatch();
//   const { loading, roles, branches, employees,  } = useSelector(
//     (state) => state.permissions
//   );

//   const [role, setRole] = useState("");
//   const [branch, setBranch] = useState("");
//   const [user, setUser] = useState("");
//   const [openCard, setOpenCard] = useState(null);
//   const [permissionsData, setPermissionsData] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);
//   const [filteredRoles, setFilteredRoles] = useState([]);



  

//   // Fetch roles, branches, employees
//   useEffect(() => {
//     dispatch(fetchRoles());
//     dispatch(fetchBranches({ fetchAll: true }));
//  if (branch && role) {
//     // Fetch employees with branch + role filter
//     dispatch(fetchEmployees({ fetchAll: true, branchName: branch, roleName: role }));
//   } 

// }, [dispatch, branch, role]);
// useEffect(() => {
//   if (!branch || !role) {
//     setFilteredEmployees([]);
//     setUser("");
//     return;
//   }

//   setFilteredEmployees(employees);
// }, [branch, role, employees]);



//     console.log("roles from redux:", roles); // 👈 Add this here

//   // Initialize permission data
//   useEffect(() => {
//     const allData = Object.entries(allModules).map(([key, mod]) => ({
//       id: key,
//       title: mod.title,
//       checked: false,
//       permissions: mod.permissions.map((p) => ({ ...p, checked: false })),
//     }));
//     setPermissionsData(allData);
//   }, []);



//   // Filter employees based on branch + role
//   useEffect(() => {
//     if (!branch || !role) {
//       setFilteredEmployees([]);
//       setUser("");
//       return;
//     }

//     let filtered = employees.filter(
//       (emp) =>
//         emp.branchName?.toLowerCase() === branch.toLowerCase() ||
//         emp.branchId === branch
//     );

//     filtered = filtered.filter(
//       (emp) =>
//         emp.roleName?.toLowerCase() === role.toLowerCase() ||
//         emp.roleId === role
//     );

//     setFilteredEmployees(filtered);
//     setUser("");
//   }, [branch, role, employees]);

//   const toggleCard = (id) => setOpenCard((prev) => (prev === id ? null : id));

//   const toggleCardChecked = (cardId) => {
//     setPermissionsData((prev) =>
//       prev.map((card) =>
//         card.id === cardId
//           ? {
//               ...card,
//               checked: !card.checked,
//               permissions: card.permissions.map((p) => ({
//                 ...p,
//                 checked: !card.checked,
//               })),
//             }
//           : card
//       )
//     );
//   };

//   const togglePermissionChecked = (cardId, index) => {
//     setPermissionsData((prev) =>
//       prev.map((card) =>
//         card.id === cardId
//           ? {
//               ...card,
//               permissions: card.permissions.map((p, i) =>
//                 i === index ? { ...p, checked: !p.checked } : p
//               ),
//               checked: card.permissions.every((p, i) =>
//                 i === index ? !p.checked : p.checked
//               ),
//             }
//           : card
//       )
//     );
//   };

//   const handleSave = () => {
//     if (!user) return;

//     const selectedPermissions = permissionsData
//       .flatMap((card) => card.permissions.filter((p) => p.checked))
//       .map((p) => p.label);

//     const selectedEmployee = employees.find((e) => e.fullName === user);
//     const employeeId = selectedEmployee?._id || selectedEmployee?.id;
//     console.log("selectedEmployee?.id");

//     console.log(employeeId);
//     console.log(selectedEmployee?._id);
//     console.log(selectedEmployee?.id);
//     console.log("selectedEmployee?.id");

//     const payload = {
//       role,
//       branch,
//       employeeId,
//       permissions: selectedPermissions,
//     };

//     dispatch(assignPermissions(payload));
//   };

//   return (
//     <div className="permissions-page">
//       <h2 className="form-header">Assign Permissions</h2>
//       <form className="permissions-form" onSubmit={(e) => e.preventDefault()}>
       


// {/* Branch Dropdown */}
// <div className="form-group">
//   <label>Branch:</label>
//   <select
//     value={branch}
//     onChange={(e) => {
//       setBranch(e.target.value);
//       setRole(""); // reset role when branch changes
//       setUser(""); // reset user when branch changes
//     }}
//   >
//     <option value="">Select Branch</option>
//     {(Array.isArray(branches) ? branches : []).map((b) => (
//       <option key={b._id || b.id} value={b.branchName || b.name}>
//         {b.branchName || b.name}
//       </option>
//     ))}
//   </select>
// </div>

// {/* Role Dropdown */}
// <div className="form-group">
//   <label>Role:</label>
//   <select
//     value={role}
//     onChange={(e) => {
//       setRole(e.target.value);
//       setUser(""); // reset user when role changes
//     }}
//     disabled={!branch} // ✅ disabled until branch selected
//   >
//     <option value="">Select Role</option>
//     {(Array.isArray(roles) ? roles : []).map((r) => (
//       <option key={r._id || r.id} value={r.name || r.title}>
//         {r.name || r.title}
//       </option>
//     ))}

//     {Array.isArray(roles) && roles.length === 0 && (
//       <option disabled>No roles available</option>
//     )}
//   </select>
// </div>

// {/* User Dropdown */}
// <div className="form-group">
//   <label>User:</label>
//   <select
//     value={user}
//     onChange={(e) => setUser(e.target.value)}
//     disabled={!role || !branch} // ✅ disabled until branch + role selected
//   >
//     <option value="">Select User</option>
//     {filteredEmployees.map((emp) => (
//       <option key={emp._id || emp.id} value={emp.fullName}>
//         {emp.fullName}
//       </option>
//     ))}
//   </select>
// </div>




        
//       </form>

//       <div className="cards-container">
//         {permissionsData.map((card) => (
//           <div key={card.id} className="card">
//             <div className="card-header" onClick={() => toggleCard(card.id)}>
//               <label className="checkbox-label">
//                 <input
//                   type="checkbox"
//                   checked={card.checked}
//                   onChange={(e) => {
//                     e.stopPropagation();
//                     toggleCardChecked(card.id);
//                   }}
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {card.title}
//               </label>
//               <i
//                 className={`fas fa-chevron-down icon-chevron ${
//                   openCard === card.id ? "rotated" : ""
//                 }`}
//               />
//             </div>
//             <div
//               className={`card-content ${
//                 openCard === card.id ? "expanded" : ""
//               }`}
//             >
//               {card.permissions.map((perm, i) => (
//                 <div key={perm.id} className="permission-item">
//                   <i className={`${perm.icon} permission-icon`} />
//                   <input
//                     type="checkbox"
//                     checked={perm.checked}
//                     onChange={() => togglePermissionChecked(card.id, i)}
//                   />
//                   <span className="permission-label">{perm.label}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>

//       <button
//         className="save-button"
//         onClick={handleSave}
//         disabled={!role || !branch || !user || loading}
//       >
//         {loading ? "Saving..." : "Save Permissions"}
//       </button>
//     </div>
//   );
// }

// /* eslint-disable no-unused-vars */
// import React, { useState, useEffect } from "react";
// import "../assets/ManagePermission.css";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   assignPermissions,
//   fetchRoles,
//   fetchBranches,
//   fetchEmployees,
// } from "../redux/slices/permissionSlice";

// let permissionIdCounter = 1;
// const allModules = {
//   customer: {
//     title: "Customer",
//     permissions: [
//       { id: permissionIdCounter++, label: "Create Customer", icon: "fas fa-id-card" },
//       { id: permissionIdCounter++, label: "Search Customer", icon: "fas fa-search" },
//       { id: permissionIdCounter++, label: "Customer KYC", icon: "fas fa-folder" },
//       { id: permissionIdCounter++, label: "Customer Report", icon: "fas fa-file-alt" },
//     ],
//   },
//   hrmodule: {
//     title: "HR Module",
//     permissions: [
//       { id: permissionIdCounter++, label: "Employee Management", icon: "fas fa-id-badge" },
//       { id: permissionIdCounter++, label: "Attendance", icon: "fas fa-calendar-check" },
//       { id: permissionIdCounter++, label: "Payroll", icon: "fas fa-file-invoice" },
//       { id: permissionIdCounter++, label: "Leave Management", icon: "fas fa-user-clock" },
//     ],
//   },
//   loans: {
//     title: "Loans",
//     permissions: [
//       { id: permissionIdCounter++, label: "Loan Applications", icon: "fas fa-file-signature" },
//       { id: permissionIdCounter++, label: "Approvals", icon: "fas fa-check-circle" },
//       { id: permissionIdCounter++, label: "Payment Tracking", icon: "fas fa-file-invoice-dollar" },
//     ],
//   },
//   banking: {
//     title: "Banking",
//     permissions: [
//       { id: permissionIdCounter++, label: "Account Management", icon: "fas fa-university" },
//       { id: permissionIdCounter++, label: "Transactions", icon: "fas fa-exchange-alt" },
//       { id: permissionIdCounter++, label: "Reports", icon: "fas fa-chart-line" },
//     ],
//   },
//   ledger: {
//     title: "Ledger",
//     permissions: [
//       { id: permissionIdCounter++, label: "View Ledger", icon: "fas fa-book" },
//       { id: permissionIdCounter++, label: "Edit Ledger", icon: "fas fa-pen" },
//     ],
//   },
//   transactions: {
//     title: "Transactions",
//     permissions: [
//       { id: permissionIdCounter++, label: "Make Transaction", icon: "fas fa-money-bill" },
//       { id: permissionIdCounter++, label: "Transaction History", icon: "fas fa-history" },
//     ],
//   },
//   print: {
//     title: "Print",
//     permissions: [
//       { id: permissionIdCounter++, label: "Print Report", icon: "fas fa-print" },
//       { id: permissionIdCounter++, label: "Print Statement", icon: "fas fa-print" },
//     ],
//   },
//   profile: {
//     title: "Profile",
//     permissions: [
//       { id: permissionIdCounter++, label: "View Profile", icon: "fas fa-user" },
//       { id: permissionIdCounter++, label: "Edit Profile", icon: "fas fa-edit" },
//     ],
//   },
//   ccloan: {
//     title: "CC Loan",
//     permissions: [
//       { id: permissionIdCounter++, label: "CC Application", icon: "fas fa-piggy-bank" },
//       { id: permissionIdCounter++, label: "CC Approval", icon: "fas fa-thumbs-up" },
//     ],
//   },
//   additional: {
//     title: "Additional",
//     permissions: [
//       { id: permissionIdCounter++, label: "Settings", icon: "fas fa-cogs" },
//       { id: permissionIdCounter++, label: "Tools", icon: "fas fa-tools" },
//     ],
//   },
//   grouploan: {
//     title: "Group Loan",
//     permissions: [
//       { id: permissionIdCounter++, label: "Group Center", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Loan Status", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Emi Due Report Group", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Emi Due Report Member", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Create", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Loan Report", icon: "fa fa-users-cog" },
//       { id: permissionIdCounter++, label: "Group Loan Scheme", icon: "fa fa-users-cog" },
//     ],
//   },
// };

// export default function ManagePermission() {
//   const dispatch = useDispatch();
//   const { loading, roles, branches, employees } = useSelector(
//     (state) => state.permissions
//   );

//   const [role, setRole] = useState("");
//   const [branch, setBranch] = useState("");
//   const [user, setUser] = useState("");
//   const [openCard, setOpenCard] = useState(null);
//   const [permissionsData, setPermissionsData] = useState([]);
//   const [filteredEmployees, setFilteredEmployees] = useState([]);

//   // Fetch roles + branches on mount
//   useEffect(() => {
//     dispatch(fetchRoles());
//     dispatch(fetchBranches({ fetchAll: true }));
//   }, [dispatch]);

//   // Fetch employees when branch + role selected
//   useEffect(() => {
//     if (branch && role) {
//       dispatch(fetchEmployees({ fetchAll: true, branchName: branch, roleName: role }));
//     } else {
//       setFilteredEmployees([]);
//       setUser("");
//     }
//   }, [dispatch, branch, role]);

//   useEffect(() => {
//     if (!branch || !role) return;
//     setFilteredEmployees(employees);
//   }, [employees, branch, role]);

//   // Initialize default permission list
//   useEffect(() => {
//     const allData = Object.entries(allModules).map(([key, mod]) => ({
//       id: key,
//       title: mod.title,
//       checked: false,
//       permissions: mod.permissions.map((p) => ({ ...p, checked: false })),
//     }));
//     setPermissionsData(allData);
//   }, []);

//   // ✅ Fetch already assigned permissions when user changes
//   useEffect(() => {
//     if (!user) return;

//     const selectedEmployee = employees.find((e) => e.fullName === user);
//     if (!selectedEmployee) return;

//     const employeeId = selectedEmployee._id || selectedEmployee.id;
//     fetch(`https://payyug.in/api/permissions/${employeeId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (!data.permissions) return;

//         // Map API response into checkbox selections
//         setPermissionsData((prev) =>
//           prev.map((card) => {
//             const updatedPermissions = card.permissions.map((p) => ({
//               ...p,
//               checked: data.permissions.includes(p.label),
//             }));
//             return {
//               ...card,
//               permissions: updatedPermissions,
//               checked: updatedPermissions.every((p) => p.checked),
//             };
//           })
//         );
//       })
//       .catch((err) => console.error("Error fetching assigned permissions:", err));
//   }, [user, employees]);

//   const toggleCard = (id) => setOpenCard((prev) => (prev === id ? null : id));

//   const toggleCardChecked = (cardId) => {
//     setPermissionsData((prev) =>
//       prev.map((card) =>
//         card.id === cardId
//           ? {
//               ...card,
//               checked: !card.checked,
//               permissions: card.permissions.map((p) => ({
//                 ...p,
//                 checked: !card.checked,
//               })),
//             }
//           : card
//       )
//     );
//   };

//   const togglePermissionChecked = (cardId, index) => {
//     setPermissionsData((prev) =>
//       prev.map((card) =>
//         card.id === cardId
//           ? {
//               ...card,
//               permissions: card.permissions.map((p, i) =>
//                 i === index ? { ...p, checked: !p.checked } : p
//               ),
//               checked: card.permissions.every((p, i) =>
//                 i === index ? !p.checked : p.checked
//               ),
//             }
//           : card
//       )
//     );
//   };

//   const handleSave = () => {
//     if (!user) return;

//     const selectedPermissions = permissionsData
//       .flatMap((card) => card.permissions.filter((p) => p.checked))
//       .map((p) => p.label);

//     const selectedEmployee = employees.find((e) => e.fullName === user);
//     const employeeId = selectedEmployee?._id || selectedEmployee?.id;

//     const payload = {
//       role,
//       branch,
//       employeeId,
//       permissions: selectedPermissions,
//     };

//     dispatch(assignPermissions(payload));
//   };

//   return (
//     <div className="permissions-page">
//       <h2 className="form-header">Assign Permissions</h2>
//       <form className="permissions-form" onSubmit={(e) => e.preventDefault()}>
//         {/* Branch Dropdown */}
//         <div className="form-group">
//           <label>Branch:</label>
//           <select
//             value={branch}
//             onChange={(e) => {
//               setBranch(e.target.value);
//               setRole("");
//               setUser("");
//             }}
//           >
//             <option value="">Select Branch</option>
//             {(Array.isArray(branches) ? branches : []).map((b) => (
//               <option key={b._id || b.id} value={b.branchName || b.name}>
//                 {b.branchName || b.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Role Dropdown */}
//         <div className="form-group">
//           <label>Role:</label>
//           <select
//             value={role}
//             onChange={(e) => {
//               setRole(e.target.value);
//               setUser("");
//             }}
//             disabled={!branch}
//           >
//             <option value="">Select Role</option>
//             {(Array.isArray(roles) ? roles : []).map((r) => (
//               <option key={r._id || r.id} value={r.name || r.title}>
//                 {r.name || r.title}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* User Dropdown */}
//         <div className="form-group">
//           <label>User:</label>
//           <select
//             value={user}
//             onChange={(e) => setUser(e.target.value)}
//             disabled={!role || !branch}
//           >
//             <option value="">Select User</option>
//             {filteredEmployees.map((emp) => (
//               <option key={emp._id || emp.id} value={emp.fullName}>
//                 {emp.fullName}
//               </option>
//             ))}
//           </select>
//         </div>
//       </form>

//       <div className="cards-container">
//         {permissionsData.map((card) => (
//           <div key={card.id} className="card">
//             <div className="card-header" onClick={() => toggleCard(card.id)}>
//               <label className="checkbox-label">
//                 <input
//                   type="checkbox"
//                   checked={card.checked}
//                   onChange={(e) => {
//                     e.stopPropagation();
//                     toggleCardChecked(card.id);
//                   }}
//                   onClick={(e) => e.stopPropagation()}
//                 />
//                 {card.title}
//               </label>
//               <i
//                 className={`fas fa-chevron-down icon-chevron ${
//                   openCard === card.id ? "rotated" : ""
//                 }`}
//               />
//             </div>
//             <div
//               className={`card-content ${
//                 openCard === card.id ? "expanded" : ""
//               }`}
//             >
//               {card.permissions.map((perm, i) => (
//                 <div key={perm.id} className="permission-item">
//                   <i className={`${perm.icon} permission-icon`} />
//                   <input
//                     type="checkbox"
//                     checked={perm.checked}
//                     onChange={() => togglePermissionChecked(card.id, i)}
//                   />
//                   <span className="permission-label">{perm.label}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>

//       <button
//         className="save-button"
//         onClick={handleSave}
//         disabled={!role || !branch || !user || loading}
//       >
//         {loading ? "Saving..." : "Save Permissions"}
//       </button>
//     </div>
//   );
// }



/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "../assets/ManagePermission.css";
import { useDispatch, useSelector } from "react-redux";
import {
  assignPermissions,
  fetchRoles,
  fetchBranches,
  fetchEmployees,
} from "../redux/slices/permissionSlice";

let permissionIdCounter = 1;
const allModules = {
  customer: {
    title: "Customer",
    permissions: [
      { id: permissionIdCounter++, label: "Create Customer", icon: "fas fa-id-card" },
      { id: permissionIdCounter++, label: "Search Customer", icon: "fas fa-search" },
      { id: permissionIdCounter++, label: "Customer Kyc", icon: "fas fa-folder" },
      { id: permissionIdCounter++, label: "Customer Report", icon: "fas fa-file-alt" },
      { id: permissionIdCounter++, label: "Nominee", icon: "fas fa-file-alt" },
    ],
  },
  hrmodule: {
    title: "HR Module",
    permissions: [
      { id: permissionIdCounter++, label: "Employee Attendance", icon: "fas fa-id-badge" },
      { id: permissionIdCounter++, label: "Apply Leave", icon: "fas fa-calendar-check" },
      { id: permissionIdCounter++, label: "Holiday List", icon: "fas fa-file-invoice" },
      // { id: permissionIdCounter++, label: "Leave Management", icon: "fas fa-user-clock" },
    ],
  },
  loans: {
    title: "Loans",
    permissions: [
      { id: permissionIdCounter++, label: "Apply Loan", icon: "fas fa-file-signature" },
      { id: permissionIdCounter++, label: "Upload Loan Kyc", icon: "fas fa-check-circle" },
      { id: permissionIdCounter++, label: "Loan Report", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Loan Statement", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Single Loan Emi Pay", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Emi Due Report", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Collection Report", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Loan Closer Request", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Loan Closer Report", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Loan Settlement", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Loan Pre Closer Request", icon: "fas fa-file-invoice-dollar" },
      { id: permissionIdCounter++, label: "Loan Documents", icon: "fas fa-file-invoice-dollar" },
    ],
  },
  banking: {
    title: "Banking",
    permissions: [
      { id: permissionIdCounter++, label: "Saving Account", icon: "fas fa-university" },
      { id: permissionIdCounter++, label: "RD/DD Account", icon: "fas fa-exchange-alt" },
      { id: permissionIdCounter++, label: "FD/MIS Account", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "Verify Account", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "Saving Report", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "Saving Closer Report", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "RD/DD Report", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "FD/MIS Report", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "RD/DD due Report", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "Deposite Collection", icon: "fas fa-chart-line" },
      { id: permissionIdCounter++, label: "Close Account", icon: "fas fa-chart-line" },
    ],
  },
  accountant: {
    title: "Accountant",
    permissions: [
      { id: permissionIdCounter++, label: "Ledger Entry", icon: "fas fa-book" },
      { id: permissionIdCounter++, label: "Fund Transfer", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Overview", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Profit Loss", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Day Book", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Cash Book", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Voucher Entries", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Payment", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Journal", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Trial Balance", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Fy Trial Balance", icon: "fas fa-pen" },
      { id: permissionIdCounter++, label: "Fy Opening Balance", icon: "fas fa-pen" },
    ],
  },
  transactions: {
    title: "Transactions",
    permissions: [
      { id: permissionIdCounter++, label: "Saving Account Transaction", icon: "fas fa-money-bill" },
      { id: permissionIdCounter++, label: "RD/DD Account Transaction", icon: "fas fa-history" },
      { id: permissionIdCounter++, label: "RD/DD Pre Closure", icon: "fas fa-history" },
      { id: permissionIdCounter++, label: "RD/DD Single Emi Pay", icon: "fas fa-history" },
      { id: permissionIdCounter++, label: "Transaction Report", icon: "fas fa-history" },
    ],
  },
  wallet: {
    title: "Wallet",
    permissions: [
      { id: permissionIdCounter++, label: "Request Wallet Fund", icon: "fas fa-print" },
      { id: permissionIdCounter++, label: "Wallet Transaction", icon: "fas fa-print" },
    ],
  },
  // profile: {
  //   title: "Profile",
  //   permissions: [
  //     { id: permissionIdCounter++, label: "View Profile", icon: "fas fa-user" },
  //     { id: permissionIdCounter++, label: "Edit Profile", icon: "fas fa-edit" },
  //   ],
  // },
  // ccloan: {
  //   title: "CC Loan",
  //   permissions: [
  //     { id: permissionIdCounter++, label: "CC Application", icon: "fas fa-piggy-bank" },
  //     { id: permissionIdCounter++, label: "CC Approval", icon: "fas fa-thumbs-up" },
  //   ],
  // },
  // additional: {
  //   title: "Additional",
  //   permissions: [
  //     { id: permissionIdCounter++, label: "Settings", icon: "fas fa-cogs" },
  //     { id: permissionIdCounter++, label: "Tools", icon: "fas fa-tools" },
  //   ],
  // },
  grouploan: {
    title: "Group Loan",
    permissions: [
      { id: permissionIdCounter++, label: "Center Create", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Create Group", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Group Loan Apply", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Group Loan Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Emi Due Report Group", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Group Collection Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Demand Sheet", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Area Survay", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Area Suvay Report", icon: "fa fa-users-cog" },
    ],
  },
  goldloan: {
    title: "Gold Loan",
    permissions: [
      { id: permissionIdCounter++, label: "Gold Loan Apply", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Gold Loan Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Gold Loan Collection Report", icon: "fa fa-users-cog" },
    ],
  },
  vehicleloan: {
    title: "Vehicle Loan",
    permissions: [
      { id: permissionIdCounter++, label: "Vehicle Loan Apply", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Vehicle Loan Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Vehicle Loan Emi Due Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Vehicle Loan Collection Report", icon: "fa fa-users-cog" },
    ],
  },
  productloan: {
    title: "Product Loan",
    permissions: [
      { id: permissionIdCounter++, label: "Product Loan Apply", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Product Loan Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Product Loan Emi Due Report", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Product Loan Collection Report", icon: "fa fa-users-cog" },
    ],
  },
  cibil: {
    title: "Cibil",
    permissions: [
      { id: permissionIdCounter++, label: "Cibil Check", icon: "fa fa-users-cog" },
      { id: permissionIdCounter++, label: "Cibil Report", icon: "fa fa-users-cog" },
    ],
  },
};

export default function ManagePermission() {
  const dispatch = useDispatch();
  const { loading, roles, branches, employees } = useSelector(
    (state) => state.permissions
  );

  const [role, setRole] = useState("");
  const [branch, setBranch] = useState("");
  const [user, setUser] = useState("");
  const [openCard, setOpenCard] = useState(null);
  const [permissionsData, setPermissionsData] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);

  // Fetch roles + branches on mount
  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(fetchBranches({ fetchAll: true }));
  }, [dispatch]);

  // Fetch employees when branch + role selected
  useEffect(() => {
    if (branch && role) {
      dispatch(fetchEmployees({ fetchAll: true, branchName: branch, roleName: role }));
    } else {
      setFilteredEmployees([]);
      setUser("");
    }
  }, [dispatch, branch, role]);

  // ✅ Filter employees properly by branch + role
  useEffect(() => {
    if (!branch || !role) {
      setFilteredEmployees([]);
      return;
    }
    const filtered = employees.filter(
      (emp) =>
        (emp.branchName?.toLowerCase() === branch.toLowerCase() ||
          emp.branchId === branch) &&
        (emp.roleName?.toLowerCase() === role.toLowerCase() ||
          emp.roleId === role)
    );
    setFilteredEmployees(filtered);
  }, [employees, branch, role]);

  // Initialize default permission list
  useEffect(() => {
    const allData = Object.entries(allModules).map(([key, mod]) => ({
      id: key,
      title: mod.title,
      checked: false,
      permissions: mod.permissions.map((p) => ({ ...p, checked: false })),
    }));
    setPermissionsData(allData);
  }, []);

  // ✅ Prefill assigned permissions for selected user
//   useEffect(() => {
//   if (!user) return;

//   const resetPermissions = Object.entries(allModules).map(([key, mod]) => ({
//     id: key,
//     title: mod.title,
//     checked: false,
//     permissions: mod.permissions.map((p) => ({
//       ...p,
//       checked: false,
//     })),
//   }));

//   setPermissionsData(resetPermissions);
// }, [user]);

 useEffect(() => {
    if (!user) return;

    const selectedEmployee = employees.find((e) => e.fullName === user);
    if (!selectedEmployee) return;

    const employeeId = selectedEmployee._id || selectedEmployee.id;
    fetch(`https://payyug.in/api/permissions/${employeeId}`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.permissions) return;

        // Map API response into checkbox selections
        setPermissionsData((prev) =>
          prev.map((card) => {
            const updatedPermissions = card.permissions.map((p) => ({
              ...p,
              checked: data.permissions.includes(p.label),
            }));
            return {
              ...card,
              permissions: updatedPermissions,
              checked: updatedPermissions.every((p) => p.checked),
            };
          })
        );
      })
      .catch((err) => console.error("Error fetching assigned permissions:", err));
  }, [user, employees]);

  const toggleCard = (id) => setOpenCard((prev) => (prev === id ? null : id));

  const toggleCardChecked = (cardId) => {
    setPermissionsData((prev) =>
      prev.map((card) =>
        card.id === cardId
          ? {
              ...card,
              checked: !card.checked,
              permissions: card.permissions.map((p) => ({
                ...p,
                checked: !card.checked,
              })),
            }
          : card
      )
    );
  };

  const togglePermissionChecked = (cardId, index) => {
    setPermissionsData((prev) =>
      prev.map((card) =>
        card.id === cardId
          ? {
              ...card,
              permissions: card.permissions.map((p, i) =>
                i === index ? { ...p, checked: !p.checked } : p
              ),
              checked: card.permissions.every((p, i) =>
                i === index ? !p.checked : p.checked
              ),
            }
          : card
      )
    );
  };

  const handleSave = () => {
    if (!user) return;

    const selectedPermissions = permissionsData
      .flatMap((card) => card.permissions.filter((p) => p.checked))
      .map((p) => p.label);

    const selectedEmployee = employees.find((e) => e.fullName === user);
    const employeeId = selectedEmployee?._id || selectedEmployee?.id;

    const payload = {
      role,
      branch,
      employeeId,
      permissions: selectedPermissions,
    };

    dispatch(assignPermissions(payload));
  };
  const showPermissions = branch && role && user;

  return (
    <div className="permissions-page">
  <div className="permissions-header-section">
    <h2 className="permissions-form-header">Assign Permissions</h2>
  </div>

  <form className="permissions-form" onSubmit={(e) => e.preventDefault()}>
    {/* Branch Dropdown */}
    <div className="permissions-form-group">
      <label>Branch</label>
      <select
        value={branch}
        onChange={(e) => {
          setBranch(e.target.value);
          setRole("");
          setUser("");
        }}
      >
        <option value="">Select Branch</option>
        {(Array.isArray(branches) ? branches : []).map((b) => (
          <option key={b._id || b.id} value={b.branchName || b.name}>
            {b.branchName || b.name}
          </option>
        ))}
      </select>
    </div>

    {/* Role Dropdown */}
    <div className="permissions-form-group">
      <label>Role</label>
      <select
        value={role}
        onChange={(e) => {
          setRole(e.target.value);
          setUser("");
        }}
        disabled={!branch}
      >
        <option value="">Select Role</option>
        {(Array.isArray(roles) ? roles : []).map((r) => (
          <option key={r._id || r.id} value={r.name || r.title}>
            {r.name || r.title}
          </option>
        ))}
      </select>
    </div>

    {/* User Dropdown */}
    <div className="permissions-form-group">
      <label>User</label>
      <select
        value={user}
        onChange={(e) => setUser(e.target.value)}
        disabled={!role || !branch}
      >
        <option value="">Select User</option>
        {filteredEmployees.map((emp) => (
          <option key={emp._id || emp.id} value={emp.fullName}>
            {emp.fullName}
          </option>
        ))}
      </select>
    </div>
  </form>

  {/* Permission Cards */}
  {showPermissions && (
    <div className="cards-container">
      {permissionsData.map((card) => (
        <div key={card.id} className="card">
          <div className="card-header" onClick={() => toggleCard(card.id)}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={card.checked}
                onChange={(e) => {
                  e.stopPropagation();
                  toggleCardChecked(card.id);
                }}
                onClick={(e) => e.stopPropagation()}
              />
              {card.title}
            </label>

            <i
              className={`fas fa-chevron-down icon-chevron ${
                openCard === card.id ? "rotated" : ""
              }`}
            />
          </div>

          <div
            className={`card-content ${
              openCard === card.id ? "expanded" : ""
            }`}
          >
            {card.permissions.map((perm, i) => (
              <div key={perm.id} className="permission-item">
                <i className={`${perm.icon} permission-icon`} />

                <input
                  type="checkbox"
                  checked={perm.checked}
                  onChange={() => togglePermissionChecked(card.id, i)}
                />

                <span className="permission-label">{perm.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )}

  {showPermissions && (
  <button
    className="permissions-save-button"
    onClick={handleSave}
    disabled={loading}
  >
    {loading ? "Saving..." : "Save Permissions"}
  </button>
)}
</div>

  );
}
